const namespace = 'print';

export const SAVE_DETAILS = `${namespace}/SAVE_DETAILS`;
export const CLEAR_DETAILS = `${namespace}/CLEAR_DETAILS`;

export function saveDetails(from, to, order) {
  return {
    type: SAVE_DETAILS,
    order,
    from,
    to
  }
}

export function clearDetails() {
  return {
    type: CLEAR_DETAILS
  }
}


// WEBPACK FOOTER //
// ./src/actions/PrintActions.js